import { AbstractEntityMapper } from '@pf/shared-services';
import {
    SlotCreate,
    SlotDto,
    SlotRead,
    SlotSearchParams,
} from '../../entities/slot.dto';
import { Injectable } from '@angular/core';
import { PlatformWmsMapper } from '../platform-wms.mapper';
import { SlotMetadataMap } from './slot.mapping-profile';

@Injectable()
export class SlotMapper extends AbstractEntityMapper<
    SlotRead,
    SlotCreate,
    SlotDto,
    SlotSearchParams
> {
    constructor() {
        super(SlotDto, PlatformWmsMapper, SlotMetadataMap.symbols);
    }
}
